export const POINT_DE_VENTE = {
  titleLabel: 'Rechercher un point de vente',
  placeholder: 'Rechercher par point de vente',
  ou: 'Ou',
  buttonCreate: 'Créer un point de vente',
  notFoundResult: 'Aucun Résultat trouvé pour',
};

export const CREER_POINT_DE_VENTE = {
  titlePage: 'Créer un point de vente',
  labelChamp: {
    libelle: 'Nom du point de vente',
    adresse: 'Adresse du point de vente',
    marque: 'Marque',
    enseigne: 'Enseigne',
    secteurActivite: 'Secteur d’activité',
    applicationTva: 'Application TVA',
  },
  btnValider: 'Créer le point de vente',
};

export const CREER_PANNEAU = {
  titlePage: 'Créer un panneau',
  titleCommentaire: 'Commentaire',
  titlePropFinanciere: 'Proposition financière',
  labelChamp: {
    adresse: 'Adresse du panneau',
    adresseCommerciale: 'Adresse Commerciale',
    commentaire: 'Commentaire',
    regie: 'Régie',
    categorie: 'Catégorie',
    format: 'Format',
    materiel: 'Matériel',
    support: 'Support',
    azimut: 'Azimut',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    duree: 'Durée',
    prixBrutNegocie: 'Budget brut HT',
    prixNet: 'Budget net HT',
    prixBrutNegocieAnnuel: 'Budget brut annuel HT',
    prixNetAnnuel: 'Budget net annuel HT',
    tlpe: 'TLPE',
    fraisTechnique: 'Frais techniques',
    honoraires: 'Honoraires',
    honoraireFraisTraitement: 'Frais de traitement',
    adresseDetail: 'Adresse',
    codePostal: 'Code postal',
    ville: 'Ville',
    pays: 'Pays',
    latitude: 'Latitude',
    longitude: 'Longitude',
    remise: 'Remise / Majo.',
    referenceConfrere: 'Code afficheur',
    dateFinPremiereEcheance: 'Date fin 1ère échéance',
    prixUnitaireBrut: 'PU brut',
    quantiteBrut: 'Quantité brut',
    uniteQteBrut: 'Unité qté brut',
    prixUnitaireTlpe: 'PU TLPE',
    quantiteTlpe: 'Quantité TLPE',
    uniteQteTlpe: 'Unité qté TLPE',
    disposition: 'Directionnel',
    pourcentageSurface: '% de surface',
  },
  messageWarningSurface: 'La face est déjà occupée à {surfaceOccupee} % sur la période : le total dépasse 100 %',
  titleGenererProposition: 'Générer ma proposition financière',
  titreBlocBudget: 'Du {debut} au {fin}',
  btnValider: 'Créer le panneau',
  btnCalculerHonoraire: 'Calculer honoraires',
  btnGenerer: 'Générer',
  msgErrorNoPointDeVente: 'Aucun point de vente enregistré',
  modalCalculHonoraire: {
    titleModal: 'Mode de calcul des honoraires',
    subtitle: 'Sélectionner le mode de calcul ',
    mode: {
      manuel: 'Manuel',
      forfait: 'Forfait',
      pourcentage: 'Pourcentage',
      multiple: 'Multiple',
    },
    modeCalcul: 'Mode de calcul',
    pourcentage: 'Pourcentage',
    appply: 'Appliquer le pourcentage sur :',
    loc: 'Location',
    tlpe: 'TLPE',
    divers: 'Divers',
    montantHonoraireForfaitaire: 'Forfait Audit',
    montantHonoraireFraisTraitement: 'Montant frais de traitement',
    errors: {
      oneProduct: 'Vous devez appliquer le pourcentage sur au moins un produit',
    },
    honorairesPercentage: 'Honoraires %',
    titleforfait: 'Forfait',
    checkboxNetFacture: 'Net facturé',
    checkboxDivers: 'Divers',
    checkboxTlpe: 'TLPE',
    montant: 'Montant',
    lableForfait: 'Forfait',
  },
  messageErreurDate: 'La date de fin doit être supérieure à la date de début',
  modalCreation: {
    titreRegie: 'Créer une régie',
    labelRegie: 'Nom de la régie',
    titreFormat: 'Créer un format',
    labelFormat: 'Nom du format',
    titreMateriel: 'Créer un matériel',
    labelMateriel: 'Nom du matériel',
  },
  error: {
    regie: 'Le champ régie est obligatoire',
    referenceConfrere: 'Le champ code afficheur est obligatoire',
    format: 'Le champ format est obligatoire',
    materiel: 'Le champ matériel est obligatoire',
    categorie: 'Le champ catégorie est obligatoire',
    disposition: 'Le champ directionnel ne doit pas dépasser 50 caractères',
    pourcentageSurface: 'Le % de surface est obligatoire et doit être compris entre 0 et 100',
    noBudgets: 'Veuillez générer au moins un bloc budgétaire',
    type: 'Le champ type est obligatoire',
    adresse: {
      adresse1: 'Le champ adresse 1 est obligatoire',
      ville: 'Le champ ville est obligatoire',
      latitude: 'Le champ latitude est obligatoire',
      longitude: 'Le champ longitude est obligatoire',
    },
    budgets: 'Veuillez générer au moins un bloc budgétaire',
    budgetGeneration: {
      dateFin: 'La date de fin est obligatoire',
      dateDebut: 'La date de début est obligatoire',
      dateFinPremiereEcheance: 'La date de fin de première échéance doit être entre la date de début et la date de fin',
      prixNet: 'Le budget net HT est obligatoire',
      prixBrutNegocie: 'Le budget brut HT est obligatoire',
      periodesChevauche: 'Les périodes des blocs budgétaires ne doivent pas se chevaucher',
      prixUnitaireBrut: 'Le prix unitaire brut est obligatoire',
      quantiteBrut: 'La quantité brut est obligatoire',
      uniteQteBrut: 'L\'unité de quantité brut est obligatoire',
      prixUnitaireTlpe: 'Le prix unitaire TLPE est obligatoire',
      quantiteTlpe: 'La quantité TLPE est obligatoire',
      uniteQteTlpe: 'L\'unité de quantité TLPE est obligatoire',
    },
  }
}

export const LISTE_PANNEAU = {
  labelNbrPanneau: 'panneau(x)',
  libelleBtnAddExistPanel: 'Ajouter un panneau existant',
  libelleBtnCreerPanneau: 'Créer un panneau',
  labelInfoPanneau: {
    netBudgetaire: 'Budget Net HT',
    tlpe: 'TLPE',
    honoraires: 'Honoraires HT',
    fraisTechnique: 'Frais tech HT',
    sousContrat: 'Sous contrat du',
    nonRenouvele: 'Non renouvelé',
    honoraireFraisTraitement: 'Frais de traitement HT',
    referenceConfrere: 'Code afficheur : ',
  },
  noPanneau: 'Aucun panneau',
  labelNbrPanneauEncours: 'panneau(x) en cours de contrat',
  labelNbrPanneauInactifs: 'panneau(x) inactif(s)',
  modalConfirmation: {
    message: 'Etes-vous sûr de vouloir rendre inactif ce panneau ?',
    infoMessage: 'Ce panneau pourra être rendue actif si besoin.',
    libelleBtnValide: 'Effectuer',
  },
  ongletPanneau: 'Panneaux proposés ({nbre})',
  ongletEncours: 'En cours de contrat ({nbre})',
  ongletInactifs: 'Panneaux Inactifs ({nbre})',
  ongletsConcurrents: 'Concurrents ({nbre})',
  labelNbrConcurrents: '{nbre} Concurrents',
  montantHonoraireForfaitaire: 'Forfait Audit',
  assistant: 'Chargé de budget',
};
export const MODIFIER_POINT_DE_VENTE = {
  titlePage: 'Modifier un point de vente',
  labelChamp: {
    libelle: 'Nom du point de vente',
    adresse: 'Adresse du point de vente',
    marque: 'Marque',
    enseigne: 'Enseigne',
  },
  btnValider: 'Modifier',
};

export const MODIFIER_PANNEAU = {
  titlePage: 'Modifier un panneau {referencePanneau}',
  titleCommentaire: 'Commentaire',
  titlePropFinanciere: 'Proposition financière',
  labelChamp: {
    adresse: 'Adresse du panneau',
    commentaire: 'Commentaire',
    regie: 'Régie',
    categorie: 'Catégorie',
    format: 'Format',
    materiel: 'Matériel',
    support: 'Support',
    azimut: 'Azimut',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    duree: 'Durée',
    prixBrut: 'Prix brut',
    prixBrutNegocie: 'Prix brut négocié',
    netAnnuel: 'Net période',
    netBudgetaire: 'Net facturé',
    tlpe: 'TLPE',
    fraisTechnique: 'Frais technique',
    honoraires: 'Honoraires',
  },
  btnValider: 'Modifier',
  btnTerminer: 'Terminer',
  btnArchiver: 'Archiver',
  btnDesarchiver: 'Désarchiver',
  msgErrorNoPointDeVente: 'Aucun point de vente enregistré',
}

export const CONCURRENT = {
  pointCentral: 'Point central',
  searchConcurrent: 'Recherche concurrent',
  nbreConcurrentSelectionne: '{nbre} Concurrent(s) sélectionné(s)',
  toutSelectionner: 'Tout sélectionner',
  toutDeselectionner: 'Tout desélectionner',
  btnParametrer: 'Paramétrer',
  btnRetour: 'Retour',
  btnAnnuler: 'Annuler',
  btnAjouter: 'Ajouter',
  titleParametrerConcurrent: 'Paramétrer mes concurrents',
  table: {
    logo: 'Logo',
    nomCommercial: 'Nom commercial',
    enseigne: 'Enseigne',
    adresse: 'Adresse',
    secteurActivite: 'Secteur activité',
    marque: 'Marque',
  },
  sansSecteurActivite: 'Sans secteur d\'activité',
  notFoundResult: 'Aucun Résultat trouvé pour',
  modalConfirmation: {
    message: 'Etes-vous sûr de vouloir archiver ce concurrent ?',
    libelleBtnValide: 'Oui',
    libellebtnCancel: 'Non',
    msgSuccess: 'Concurrent archivé avec succès',
  },
}

export const DEVIS = {
  errors: {
    productWithError: 'Il y a des erreurs de données sur ce panneau',
    productsWithError: 'Il y a des erreurs de données sur certains panneaux de la recommandation',
    leastOneProduct: 'Vous devez saisir au minimum un panneau dans la recommandation.',
    anneeSemaineRequired: 'Vous devez sélectionner une semaine pour chaque produit réseau',
    qteFacesSouhaiteesInf: 'Le nombre de faces souhaitées doit être supérieur à 0.',
    notProposableLc: 'La face {ref} n\'est pas proposable en vente LC',
    sansSuiteForbiddenWithOrder: 'Impossible de classer ce devis sans suite car un ou des acomptes sont rattachés à ce devis',
    faceDateOverlap: 'Impossible de vendre la même face dans le même recommandation avec des dates se chevauchant',
    leastOneCustomer: 'Vous devez sélectionner au moins un client par devis.',
    fusionEcheancierVenteInterne: 'Si vous vendez un produit d\'une autre société, vous ne pouvez pas avoir un échéancier regroupé',
    needDiscount: 'Vous devez renseigner la remise',
    normalLine: 'Une ligne de devis est nécessaire entre 2 lignes de remises',
    leastOneAdvertiser: 'Vous devez indiquer au moins un annonceur par devis.',
    leastOnePayer: 'Vous devez indiquer au minimum un payeur par devis.',
    pourcentageDivision: 'La somme des pourcentages de facturation des payeurs doit être égale à 100%.',
    amountDivision: 'La somme des quotes-parts de facturation doit être égale au montant total du devis.',
    proxyNotRepresentative: 'Un client ne peut être annonceur et mandataire sur un même devis.',
    unitPriseLessZero: 'Le prix unitaire des produits doit être supérieur à 0.',
    quantityLessZero: 'La quantité des produits doit être supérieure à 0.',
    sameProduct: 'Impossible d\'ajouter le même produit à la même date',
    discountBetween0100: 'La remise de la ligne en pourcentage doit être entre 0 et 100',
    discountBetween0Amount: 'La remise de la ligne en montant doit être entre 0 et le montant de celle-ci',
    notSameDivisionType: 'Les quotes-parts des payeurs doivent être du même type.',
    saveImpossible: 'Enregistrement du devis impossible.',
    editImpossible: 'Modification du devis impossible.',
    quotationNotfound: 'Le devis n\'a pas été trouvé.',
    notSaveState: 'L\'état du devis doit être "enregistré".',
    agenceId: 'Vous devez sélectionner une agence.',
    notQuotation: 'La recommandation ne peut être créée qu\'à partir d\'un devis.',
    notOrder: 'Aucune recommandation n\'a été générée.',
    sumMontantAcompteGreat: 'La somme des montants des acomptes dépasse le montant total du devis.',
    acompteMultipayeurForbidden: 'Le multipayeur est impossible avec des devis ayant des acomptes.',
    ShoudContainsLocationOrBillBoard: 'La vente doit contenir au moins une ligne',
    TotalHtLowerThanDiscountLine: 'La remise dépasse le montant de la vente',
    etatObtenu: 'Au moins une ligne de vente contient un état obtenu à "{etatObtenu}"',
    waitForOrder: 'Au moins une ligne de vente est en attente de validation',
    faceNotAvailable: 'Une des faces sélectionnées dans un réseau n\'est pas disponible',
    faceNotAvailableInSelection: 'La face {face} n\'est pas disponible à la sélection pour le réseau {reseau} à la semaine {semaine}',
    sameFaceInSameWeek: 'La même face ne peut pas être sélectionnée à la même période sur différents réseaux',
    faceSelectGreaterThanFaceWish: 'Le nombre de faces sélectionnées est plus grand que le nombre de faces souhaitées',
    lineMustBeBloque: 'Pour sélectionner des faces, l\'état d\'option et blocage de la ligne doit être à "bloqué"',
    newCommandeLigneAtEnd: 'Les nouvelles lignes de vente ajouté à un devis partiellement commandé doivent être à la fin du devis',
    onlyOnePayeur: 'Impossible d\'avoir plusieurs payeur si le role est différent de \'Régie\'',
    noRegroupementPerso: 'Impossible d\'avoir un regroupement personalisé si le le role est différent de \'Régie\'',
    echeancierManuelShouldHaveEcheancierLignes: 'Un échéancier manuel doit avoir des lignes d\'échéanciers',
    googleMapKeyInvalid: 'La clef API google est invalide',
    sameBillingType: 'Les lignes de recommandation de l\'échéancier doivent avoir le même type de facturation',
    noMoreOneHundred: 'Le total des commissions ne doit pas faire plus que 100%',
    parutionNeeded: 'La parution est obligatoire pour le produit: {produit}',
    sameSupplier: 'Les lignes de recommandation de l\'échéancier doivent avoir le même fournisseur',
    lockedClient: 'L\'intervenant {nomCommercial} est Totalement bloqué',
    remiseInterditeCompta: 'Interdit d\'ajouter une ligne de remise',
    savedStateRRequired: 'Le devis doit être à l\'état "enregistré"',
    hasReferenceHavas: 'Impossible de classer le devis sans suite car il est relié à une référence Havas',
    hasReferenceHavasWithCode: 'Impossible de classer le devis {code} sans suite car il est relié à une référence Havas',
    savedStateRRequiredWithCode: 'Le devis {code} doit être à l\'état "enregistré"',
    sansSuiteForbiddenWithOrderWithCode: 'Impossible de classer le devis {code} sans suite car un ou des acomptes sont rattachés à ce devis',
    wrongSigneEcheancier: 'Problème de signe sur les échéances',
    commandeIntervenantReferenceHavasRequired: 'Tout les intervenants du devis doivent avoir une référence Havas',
    themeRequired: 'La recommandation doit avoir un thème de campagne',
    apiSpotHavasErrorDevis: '[Spot Havas] Problème: {probleme}',
    name: {
      role: 'Rôle',
      libelleLigneCommande: 'Libellé de la ligne',
      quantiteLigneCommande: 'Quantité de la ligne',
      prixUnitaireLigneCommande: 'Prix unitaire de la ligne',
      remiseLigneCommande: 'Remise de la ligne',
      tauxTvaLigneCommande: 'Taux de Tva de la ligne',
      dateDevisCommande: 'La date de devis',
      dateValidite: 'Date de validité',
      repartitionIntervenant: 'Quote-part facturation',
      tauxPenalite: 'Taux de pénalité',
      tauxEscompte: 'Taux d\'escompte',
      remise: 'Remise',
      numStand: 'N° stand',
      nomDispositif: 'Nom du dispositif',
      materielTypeId: 'Type de matériel',
      dispositifTypeId: 'Type de dispositif',
      materielFormatId: 'Format',
    },
    annonceurWithSameExonerationTva: 'Tous les annonceurs doivent être éxonérés de TVA',
    ligneCommandeWithZeroTva: 'Si un annonceur est exonéré de TVA, les lignes de ventes doivent avoir un taux de TVA à 0',
    partial: {
      alreadyOrdered: 'Une ligne de recommandation est déjà commandée',
      insideBundle: 'Une ligne de recommandation est dans un regroupement',
      insideCustomBundle: 'Une ligne de recommandation est dans un réseau personnalisé',
      notQuotation: 'Une ligne de recommandation n\'existe pas dans le devis',
      lineWrongType: 'Les lignes de recommandation doivent être de type regroupement, personnalisé ou normal. Mais une ligne était de type "{typeLigne}"',
      etatSuiviId: 'L\'état de suivi dans les lignes de suivi administratif',
    },
    productPurchase: 'Le produit {libelle} doit avoir un produit opposé de sens achat',
    ligneCommandeWithoutLigneLocation: 'La vente du réseau {reseau} doit avoir une ligne location',
    remiseRegieshouldBeLast: 'La remise régie de la ligne {libelle} du produit {produit} doit être la dernière',
    remiseRegieOnlyOne: 'On ne doit avoir qu\'une seule remise régie pour la ligne {libelle} du produit {produit}',
    remiseRegieMustBePreceded: 'La remise régie de la ligne {libelle} du produit {produit} doit être précédée d\'une ligne sous total',
    remiseRegieshouldBeLastWithoutRegroupement: 'La remise régie de la ligne {libelle} doit être la dernière',
    remiseRegieOnlyOneWithoutRegroupement: 'On ne doit avoir qu\'une seule remise régie pour la ligne {libelle}',
    remiseRegieMustBePrecededWithoutRegroupement: 'La remise régie de la ligne {libelle} doit être précédée d\'une ligne sous total',
    negativeNormalCommandLineForbidden: 'Il est interdit d\'avoir une ligne de recommandation négative',
    negativeNormalCommandForbidden: 'Il est interdit d\'avoir un devis négatif',
    SansSuiteForbiddenMoveWithCode: 'Impossible de classer le devis {code} sans suite car il a une signature dont l\'état de la demande est "envoyée" ou "signée".',
    SansSuiteForbiddenMove: 'Impossible de classer le devis sans suite car il a une signature dont l\'état de la demande est "envoyée" ou "signée".',
    dateFinEcheancierLigneNotBeLessThanDateDebut: 'La date de fin de la ligne d\'écheance pour du produit "{libelle}" ne peut être antérieure à sa date de début ({dateDebut}).',
    dateFinEcheancierLigneNotBeLessThanDateDebutMulti: 'La date de fin de la ligne d\'écheance ne peut être antérieure à sa date de début ({dateDebut}) pour les produits suivants : \n{libelle}',
  }
}

export const AJOUT_PRODUIT_EXISTANT = {
  modalAddTitle: 'Ajout de panneaux existant',
  column: {
    code: 'Code',
    regie: 'Régie',
    format: 'Format',
    materiel: 'Matériel',
    adresse: 'Adresse',
    codePostal: 'CP',
    ville: 'Ville',
  },
  dateDemontage: 'Date de démontage :'
}
